import React from 'react';
import {Route, Redirect} from "react-router-dom";
import {isAuthenticaded} from '../../services/Authentication'

export default ({children, ...rest}) => {

  const isAuthenticated = isAuthenticaded()

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}